import React from 'react';
import { Dialog, DialogContent } from '@mui/material';
import { colors, spacing, borderRadius } from '../../constants';
import { getStatusColor } from '../../utils/projectsUtils';
import DialogHeader from './DialogHeader';
import DialogFooter from './DialogFooter';
import AddProjectForm from './AddProjectForm';

/**
 * AddProjectDialog Component
 * Dialog for adding new projects
 */
const AddProjectDialog = ({
  open,
  onClose,
  formData,
  onInputChange,
  onSubmit,
  submitLoading,
  getStatusColor,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '16px',
          boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
          minHeight: '650px',
          maxHeight: '90vh',
        },
      }}
    >
      <DialogHeader title="Add New Project" onClose={onClose} />
      <DialogContent
        sx={{
          px: spacing.lg,
          py: spacing.md,
          overflowY: 'auto',
          '&::-webkit-scrollbar': {
            width: '6px',
          },
          '&::-webkit-scrollbar-track': {
            background: colors.backgroundLight,
          },
          '&::-webkit-scrollbar-thumb': {
            background: colors.borderDefault,
            borderRadius: '3px',
          },
        }}
      >
        <AddProjectForm
          formData={formData}
          onInputChange={onInputChange}
          getStatusColor={getStatusColor}
        />
      </DialogContent>
      <DialogFooter
        onCancel={onClose}
        onSubmit={onSubmit}
        submitLoading={submitLoading}
        submitLabel="Save Project"
      />
    </Dialog>
  );
};

export default AddProjectDialog;
